import { useLocation } from "react-router-dom";
import { useI18n } from "../../i18n";
import { SectionBanner } from "./SectionBanner";

const headings: Record<string, string> = {
  "/features": "nav.features", "/donate": "nav.donate", "/download": "nav.download", "/changelog": "changelog.title",
  "/faq": "nav.faq", "/support": "nav.support",
};

/** One persistent renderer, outside lazy page content: navigation only changes its heading. */
export function RouteSectionBanner() {
  const { pathname } = useLocation();
  const { t } = useI18n();
  const docs = pathname === "/docs" || pathname.startsWith("/docs/");
  const key = docs ? "nav.docs" : headings[pathname];
  if (!key) return null;
  return <SectionBanner title={t(key)} headingAs={docs ? "p" : "h1"} />;
}
